export class TextParagraph {
  constructor({ title = '', body = '' }) {
    this.title = title;
    this.body = body;
  }
}
